import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { CheckboxModule } from 'primeng/checkbox';

import { TranslatorLazyModule } from '../../../shared/services/translate/translator-lazy.module';

import { Selector } from './selector.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ListboxModule,
    ButtonModule,
    InputTextModule,
    TranslatorLazyModule,
    MenuModule,
    CheckboxModule
  ],
  declarations: [
    Selector
  ],
  providers: [],
  exports: [Selector]
})
export class SelectorModule { }
